import useRouteMetadata from '@/composables/routeMetadata.js'
import { hideIntercomLauncher, showIntercomLauncher } from '@/homepage/plugins/intercom.js'
import { isTest } from '@shared/utils/environment.js'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { computed, ref, toValue, watch } from 'vue'

export const useIntercomStore = defineStore('intercom', () => {
  const { hideIntercomLauncher: hideForRoute } = useRouteMetadata()

  const intercomAvailable = ref(!!window.Intercom)
  const hideRequestId = ref(0)
  const hideRequests = ref({})

  if (!intercomAvailable.value && !isTest) {
    const timeout = setInterval(() => {
      intercomAvailable.value = !!window.Intercom
      if (intercomAvailable.value) {
        clearInterval(timeout)
      }
    }, 250)
  }

  const shouldHideIntercomLauncher = computed(() =>
    hideForRoute.value || Object.values(hideRequests.value).some(predicate =>
      toValue(predicate) === true || predicate === null
    )
  )

  watch([shouldHideIntercomLauncher, intercomAvailable], ([shouldHide, available]) => {
    if (available) {
      if (shouldHide) {
        hideIntercomLauncher()
      } else {
        showIntercomLauncher()
      }
    }
  }, { immediate: true })

  function addHideRequest(predicate = null) {
    const id = hideRequestId.value++
    hideRequests.value[id] = predicate
    return id
  }

  function removeHideRequest(id) {
    delete hideRequests.value[id]
  }

  return {
    intercomAvailable,
    hideRequestId,
    hideRequests,
    shouldHideIntercomLauncher,
    addHideRequest,
    removeHideRequest
  }
})

import.meta.hot?.accept(acceptHMRUpdate(useIntercomStore, import.meta.hot))
